var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgLoginBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 359,
    viewBox: "0 0 1920 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264 359.56V299.812L323.33 240.9V299.812L264 359.56Z",
    fill: "#79C3AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.33 359.56V299.812L382.659 240.9V299.812L323.33 359.56Z",
    fill: "#79C3AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.066 239.903C108.381 239.903 91.8581 243.007 76.4424 249.037C61.0267 255.068 47.0196 263.907 35.221 275.05C23.4223 286.193 14.0631 299.422 7.67771 313.982C1.29231 328.541 -1.99421 344.145 -1.99421 359.904L125.066 359.904L125.066 239.903Z",
    fill: "#FEB449"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.007 240.271C118.007 256.029 121.293 271.634 127.679 286.193C134.064 300.752 143.423 313.981 155.222 325.125C167.021 336.268 181.028 345.107 196.443 351.138C211.859 357.168 228.382 360.272 245.067 360.272L245.067 240.271L118.007 240.271Z",
    fill: "#FEB449"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 240.807C135.678 240.807 152.2 237.703 167.616 231.673C183.031 225.642 197.038 216.803 208.837 205.66C220.636 194.516 229.995 181.288 236.38 166.728C242.766 152.169 246.052 136.564 246.052 120.806L118.992 120.806L118.992 240.807Z",
    fill: "#FEB449"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.924 240.81C119.924 225.051 116.82 209.446 110.789 194.887C104.759 180.328 95.9196 167.099 84.7764 155.956C73.6332 144.812 60.4043 135.973 45.845 129.942C31.2857 123.912 15.6812 120.808 -0.0776472 120.808L-0.0776367 240.81L119.924 240.81Z",
    fill: "#FEB449"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.264 0.832294C175.156 0.832294 168.117 2.2324 161.55 4.95267C154.983 7.67294 149.016 11.6601 143.99 16.6865C138.964 21.7129 134.977 27.6801 132.257 34.2474C129.536 40.8147 128.136 47.8535 128.136 54.9619L182.264 54.9619L182.264 0.832294Z",
    fill: "#79C3AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.782 108.606C188.89 108.606 195.929 107.206 202.496 104.486C209.063 101.766 215.03 97.7784 220.056 92.752C225.083 87.7256 229.07 81.7584 231.79 75.1911C234.51 68.6238 235.91 61.585 235.91 54.4766L181.782 54.4766L181.782 108.606Z",
    fill: "#79C3AA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.91 54.9619C235.91 47.8535 234.51 40.8147 231.79 34.2474C229.07 27.6801 225.083 21.7129 220.056 16.6865C215.03 11.6601 209.063 7.67294 202.496 4.95267C195.929 2.2324 188.89 0.832294 181.782 0.832294V54.9619H235.91Z",
    fill: "#79C3AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.136 54.4766C128.136 61.585 129.536 68.6238 132.257 75.1911C134.977 81.7584 138.964 87.7256 143.99 92.752C149.016 97.7784 154.983 101.766 161.55 104.486C168.117 107.206 175.156 108.606 182.264 108.606L182.264 54.4766L128.136 54.4766Z",
    fill: "#79C3AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 216C1901.22 216 1882.63 219.699 1865.28 226.885C1847.93 234.072 1832.16 244.605 1818.88 257.884C1805.6 271.163 1795.07 286.927 1787.89 304.276C1780.7 321.626 1777 340.221 1777 359L1920 359L1920 216Z",
    fill: "#79C3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLoginBottom);
export default __webpack_public_path__ + "static/media/bg_login_bottom.00135cacaf26948216ca33214bc57cc1.svg";
export { ForwardRef as ReactComponent };